angular.module('lf.desktop')

.directive('hoverImage', function () {
  return function link (scope, el, attrs) {
    var $defaultImage = el.find('.hover-image__state_default');
    var $hoverImage = el.find('.hover-image__state_hover');

    el
      .on('mouseenter', function () {
        $defaultImage.addClass('hover-image__state_hidden');
        $hoverImage.removeClass('hover-image__state_hidden');
      })
      .on('mouseleave', function () {
        $defaultImage.removeClass('hover-image__state_hidden');
        $hoverImage.addClass('hover-image__state_hidden');
      });
  }
});
